import { Controller } from "@hotwired/stimulus"

// Загрузка фото получателя в веб-генераторе: миниатюры выбранных файлов и
// предупреждение, если их больше лимита (сервер всё равно проверит).
export default class extends Controller {
  static targets = ["input", "previews", "note"]
  static values = { max: Number }

  connect() {
    this.urls = []
    this.defaultNote = this.noteTarget.textContent
  }

  disconnect() {
    this.revoke()
  }

  preview() {
    this.revoke()
    this.previewsTarget.innerHTML = ""

    const files = Array.from(this.inputTarget.files || [])
    files.forEach((file) => {
      const url = URL.createObjectURL(file)
      this.urls.push(url)

      const img = document.createElement("img")
      img.src = url
      img.alt = file.name
      this.previewsTarget.appendChild(img)
    })

    const over = files.length > this.maxValue
    this.noteTarget.classList.toggle("is-error", over)
    this.noteTarget.textContent = over
      ? `Слишком много фото: выбрано ${files.length}, можно не больше ${this.maxValue}.`
      : this.defaultNote
  }

  revoke() {
    this.urls.forEach((url) => URL.revokeObjectURL(url))
    this.urls = []
  }
}
